module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    class: ("button button--" + _vm.type),
    attrs: {
      "to": _vm.to
    }
  }, [(_vm.type === 'border') ? _c('svg', {
    staticClass: "button__border"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-border"
    }
  })]) : _c('span', {
    staticClass: "button__bg"
  }, [_c('svg', {
    staticClass: "button__fold button__fold--c"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-c"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--b"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-b"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "button__fold button__fold--a"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#button-fold-a"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "button__label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65ecdc90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/ButtonLink.vue
// module id = 639
// module chunks = 1